import { Action } from '@ngrx/store';
import { ProtocolModel } from '../../../_sdk/ems-devices/protocol.model';
import { ModelCollection } from '../../../_sdk/collection.model';

export const LOAD = 'PROTOCOL_LOAD';
export const LOAD_COMPLETE = 'PROTOCOL_LOAD_COMPLETE';

export const INSERT = 'PROTOCOL_INSERT';
export const INSERT_COMPLETE = 'PROTOCOL_INSERT_COMPLETE';

export const UPDATE = 'PROTOCOL_UPDATE';
export const UPDATE_COMPLETE = 'PROTOCOL_UPDATE_COMPLETE';

export const DELETE = 'PROTOCOL_DELETE';
export const DELETE_COMPLETE = 'PROTOCOL_DELETE_COMPLETE';

export const DISPOSE = 'PROTOCOL_DISPOSE';

export class Load implements Action {
    public readonly type = LOAD;
}

export class LoadComplete implements Action {
    public readonly type = LOAD_COMPLETE;

    constructor(public payload: ModelCollection<ProtocolModel>) { }
}

export class Insert implements Action {
    public readonly type = INSERT;

    constructor(public payload: ProtocolModel) { }
}

export class InsertComplete implements Action {
    public readonly type = INSERT_COMPLETE;

    constructor(public payload: ProtocolModel) { }
}

export class Update implements Action {
    public readonly type = UPDATE;

    constructor(public payload: ProtocolModel) { }
}

export class UpdateComplete implements Action {
    public readonly type = UPDATE_COMPLETE;

    constructor(public payload: ProtocolModel) { }
}

export class Delete implements Action {
    public readonly type = DELETE;

    constructor(public payload: ProtocolModel) { }
}

export class DeleteComplete implements Action {
    public readonly type = DELETE_COMPLETE;

    constructor(public payload: ProtocolModel) { }
}

export class Dispose implements Action {
    public readonly type = DISPOSE;
}

export type Actions =
    Load | LoadComplete
    | Insert | InsertComplete
    | Update | UpdateComplete
    | Delete | DeleteComplete
    | Dispose;
